<template>
    <div v-if="showBanner" class="cookie-banner">
      <p class="cookie-message">
        This website stores and accesses information on your device, such as cookies.
      </p>
      <button class="cookie-button" @click="acceptCookies">I understand</button>
    </div>
  </template>
  
  <script>
  import Cookies from 'js-cookie'
  
  export default {
    name: 'CookieBanner',
    data() {
      return {
        showBanner: !Cookies.get('CookieConsent')
      }
    },
    methods: {
      acceptCookies() {
        Cookies.set('CookieConsent', 'true', { expires: 150 })
        this.showBanner = false
      }
    }
  }
  </script>
  
  <style scoped>
  .cookie-banner {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #1E1D1A;
    color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    z-index: 1000;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .cookie-message {
    margin-right: 16px;
  }
  
  .cookie-button {
    display: flex;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background: linear-gradient(180deg, #81B64C 0%, #5D9948 100%);
    color: white;
    font-size: 14px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    box-shadow:
        0px 1px 0px 0px rgba(178, 224, 104, 0.40) inset,
        0px -1px 0px 0px #45753C inset,
        0px 2px 4px 0px rgba(178, 224, 104, 0.50) inset,
        0px -2px 4px 0px rgba(69, 117, 60, 0.50) inset,
        0px 1px 2px 0px rgba(0, 0, 0, 0.14),
        0px 2px 4px 0px rgba(0, 0, 0, 0.10);
  }

  .cookie-button:hover {
    background:
        linear-gradient(
        180deg,
        rgba(178, 224, 104, 0.5) 0%,
        rgba(178, 224, 104, 0) 100%
        ),
        linear-gradient(180deg, #81b64c 0%, #5d9948 100%);
    box-shadow:
        0px 1px 0px 0px rgba(216, 250, 157, 0.4) inset,
        0px 2px 4px 0px rgba(216, 250, 157, 0.5) inset,
        0px -1px 0px 0px #45753c inset,
        0px -2px 4px 0px rgba(69, 117, 60, 0.5) inset,
        0px 1px 2px 0px rgba(0, 0, 0, 0.14),
        0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    }
  </style>
  